import React, { useState, useEffect } from 'react';
import { Typography, TextField, Button, CircularProgress, Paper, useMediaQuery, Checkbox, FormControlLabel, makeStyles } from "@material-ui/core";
//import { useNotify } from "react-admin";
import { customTheme } from './customTheme';
import { useParams, useHistory } from "react-router-dom";
import config from './config.json';

import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import imageCompression from 'browser-image-compression';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    imageContainer: {
        backgroundPosition: "center",
        backgroundSize: "cover",
        paddingTop: "60%",
        position: "relative",
        borderRadius: 8,
        border: "1px solid #888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    removeButton: {
        position: "absolute",
        top: 3,
        right: 2,
        width: 21,
        height: 21,
        backgroundColor: "#fff",
        borderRadius: 200,
        border: "1px solid #888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            cursor: "pointer"
        },
    }
});

export default function UpdateParkingProfileInfo(props) {
    //const notify = useNotify();
    const { id } = useParams();
    const navigate = useHistory()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [parkingAddress, setParkingAddress] = useState("")
    const [facilities, setFacilities] = useState({
        underground_parking: { label: "Underground Parking", value: false },
        proper_lighting: { label: "Proper Lighting", value: false },
        multilevel_parking: { label: "Multilevel Parking", value: false },
        security_camera: { label: "Security Camera", value: false },
        boom_barrier: { label: "Boom Barrier", value: false },
        security_guard: { label: "Security Guard", value: false },
        lift: { label: "Lift", value: false },
        electric_charging: { label: "Electric Charging", value: false }
    })
    const [loading, setLoading] = useState("")
    const [pageLoading, setPageLoading] = useState(false)
    const [images, setImages] = useState([]);

    const handleChange = (event) => {
        setFacilities({ ...facilities, [event.target.name]: { ...facilities[event.target.name], value: event.target.checked } })
    };

    const getParkingInfo = () => {
        setPageLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/parking/info/${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setParkingAddress(json.data.parking_address)
                    setFacilities(json.data.parkingFacilities)
                    if (json.data.parking_images) {
                        setImages(JSON.parse(json.data.parking_images))
                    }
                    setPageLoading(false)
                } else {
                    notify(json.message, "info");
                    setPageLoading(false)
                }
            })
            .catch(e => {
                console.log(e)
                setPageLoading(false)
                notify("Check your internet connection", "warning");
            });
    }

    const updateParkingInfo = async () => {

        if (parkingAddress === "" || parkingAddress == null) {
            return notify("Name is Required", "warning")
        }
        setLoading(true)
        const data = new FormData();
        data.append("parking_info_id", id);
        data.append("parking_address", parkingAddress);
        data.append("parking_facilities", JSON.stringify(facilities));

        await Promise.all(images.map(async (img, index) => {
            if (img.substr(0, 4) === "blob") {
                const file = await fetch(img).then(r => r.blob());
                data.append("img_file", file, `parking_img_${new Date().valueOf()}.jpg`);
            } else {
                return data.append(`img_url`, img);
            }
        }))

        fetch(`${config.HOST_NAME}/crm/v3/parking/info`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: data,
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
                    setLoading(false)
                    navigate.push('/parking/profile')
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                setLoading(false);
                notify("Something Went Wrong", "warning");
            });
    }

    useEffect(() => {
        getParkingInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <Paper style={{ padding: isSmallDevice ? "0 22px 25px" : "25px 22px", boxShadow: isSmallDevice ? "none" : undefined }}>

            <div style={{ borderBottom: "1px solid #ddd", alignItems: "center", paddingBottom: 15, marginBottom: 20, textAlign: "center" }}>
                <Typography>Update Parking</Typography>
            </div>
            {
                pageLoading ? <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} /> :
                    <div>

                        <TextField
                            variant="outlined"
                            size="small"
                            label="Parking Address"
                            value={parkingAddress}
                            onChange={event => setParkingAddress(event.target.value)}
                            style={{ display: "block", marginBottom: 20 }}
                            fullWidth
                        />
                        {/* {Object.keys(FACILITIES).map(facility => (
                            <RaCheckBoxInput key={facility} source={facility} label={FACILITIES[facility].label} />
                        ))} */}

                        <CustomImagesInput images={images} setImages={setImages} />

                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 300px))", marginTop: 20 }}>
                            {
                                Object.keys(facilities).map(facility => (
                                    <FormControlLabel
                                        control={<Checkbox checked={facilities[facility].value} onChange={handleChange} name={facility} />}
                                        label={facilities[facility].label}
                                    />
                                ))
                            }
                        </div>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={updateParkingInfo}
                            style={{ textTransform: "none", display: "block", marginTop: 20 }}
                            disableElevation
                        >
                            {loading ? "Updating..." : "Update"}
                            {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                        </Button>
                    </div>
            }
        </Paper >
    );
}


function CustomImagesInput({ images, setImages }) {
    const classes = useStyles();


    const updateImages = images => {
        setImages(images);
        // onChange(JSON.stringify(images));
    };

    const addImage = async event => {
        if (event.target.files && event.target.files[0]) {
            const imageFile = event.target.files[0];
            var temp = images.concat([URL.createObjectURL(imageFile)]);
            updateImages(temp);

            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            }
            try {
                const compressedFile = await imageCompression(imageFile, options);
                temp = images.concat([URL.createObjectURL(compressedFile)]);
                updateImages(temp);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const removeImage = index => {
        const imagesArray = images.slice(0, index).concat(images.slice(index + 1));
        updateImages(imagesArray);
    };

    // useEffect(() => {
    //     if(value != null && value !== "") {
    //         try {
    //             const imagesArray = JSON.parse(value);
    //             setImages(imagesArray);
    //         } catch (e) {}
    //     }
    // }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, 150px)", gap: 15 }}>
            {images.map((imageUrl, index) => (
                <div
                    className={classes.imageContainer}
                    style={{
                        backgroundImage: `url(${imageUrl})`
                    }}
                >
                    <div className={classes.removeButton} onClick={() => removeImage(index)}>
                        <CloseIcon style={{ fontSize: 16 }} />
                    </div>
                </div>
            ))}

            {images.length < 10 && <Button className={classes.imageContainer} style={{ padding: 0, position: "relative", minHeight: 91 }}>
                <AddIcon style={{ fontSize: 40, color: "#444" }} />
                <input
                    type="file"
                    accept="image/png, image/jpeg"
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0 }}
                    onChange={addImage}
                />
            </Button>}
        </div>
    );
};